import WhatsAppBulkMessaging from "./WhatsAppBulkMessaging";

export default WhatsAppBulkMessaging;